import { useState } from "react";

export default function ShipmentCustomersSearch({
  cusQuery,
  setCusQuery,
  navItems,
  activeFilter,
  setActiveFilter,

  showCusAdvanceForm,
  setShowCusAdvanceForm,
  customersList,
  totalCustomers,
  // Advance Form Props
  filterTabCounts,
  isAdvanceMode,
  setIsAdvanceMode,
  resetRequestList,
}) {
  /*   All States
   ********************************************* */

  const [query, setQuery] = useState("");

  /*   All Functions
   ********************************************* */

  /*   All UseEffects
   ********************************************* */

  return (
    <div className="relative">
      <>
        <div className="mb-3">
          <h5 className="mt-0">Customer Search</h5>

          <form
            onSubmit={(e) => {
              e.preventDefault();
              setCusQuery(query);
            }}
            className="input-group"
          >
            <input
              type="text"
              className="form-control"
              placeholder="Search customers..."
              value={query}
              onChange={(e) => setQuery(e.target.value)}
            />
            <button
              className="btn btn-outline-primary"
              type="button"
              onClick={(e) => {
                setCusQuery(query);
              }}
            >
              <i className="mdi mdi-magnify"></i>
            </button>
            {query !== "" && (
              <button
                className="btn btn-outline-danger"
                onClick={(e) => {
                  e.preventDefault();
                  setQuery("");
                  setCusQuery("");
                }}
                type="button"
              >
                <i className="mdi mdi-close"></i>
              </button>
            )}
          </form>
        </div>
        <div>
          {isAdvanceMode ? (
            <button
              className="btn btn-danger w-100 mb-3"
              onClick={() => {
                setIsAdvanceMode(false);
              }}
            >
              Clear
            </button>
          ) : (
            <button
              className="btn btn-success w-100 mb-3"
              onClick={() => {
                setShowCusAdvanceForm(!showCusAdvanceForm);
              }}
            >
              Advance Form
            </button>
          )}
        </div>
        {navItems?.map((item) => (
          <li
            key={item.key}
            className={`list-group-item d-flex align-items-center btn py-2 px-2 ${
              activeFilter === item.key ? "active" : ""
            }`}
            style={{
              justifyContent: "flex-start",
              textAlign: "center",
              cursor: "pointer",
              background: activeFilter === item.key ? "#1976d222" : "", // subtle blue highlight
              border:
                activeFilter === item.key
                  ? "2px solid #1976d2"
                  : "1px solid #eee",
              fontWeight: activeFilter === item.key ? "bold" : "normal",
              color: activeFilter === item.key ? "#1976d2" : "#333",
              boxShadow:
                activeFilter === item.key
                  ? "0 2px 8px rgba(25,118,210,0.08)"
                  : "none",
            }}
            onClick={() => {
              setActiveFilter(item.key);
            }}
          >
            <i
              className={`mdi ${item.icon} mr-2`}
              style={{
                fontSize: "20px",
                color: activeFilter === item.key ? "#1976d2" : "#666",
              }}
            ></i>
            {
              <span className="ms-2 ">
                {item.label}
                {item?.key !== "all" ? (
                  <span className=" badge bg-success ms-2">
                    {filterTabCounts[item.key]}
                  </span>
                ) : (
                  isAdvanceMode && (
                    <>
                      <span className=" badge bg-success ms-2">
                        {filterTabCounts[item.key]}
                      </span>
                    </>
                  )
                )}
              </span>
            }
          </li>
        ))}
      </>
    </div>
  );
}
